import React from 'react';
import { GameState } from "../../../../../services/api";
import { useGameActions } from '../../../../../hooks/useGameActions';
import SituationPanel from '../../../../Common/SituationPanel';
import ActionButton from '../../../../Common/ActionButton';
import { useTranslation } from 'react-i18next';

interface SituationPlayerActingProps {
  gameState: GameState;
  playerId: string;
  onStateUpdate: (newState: GameState) => void;
}

const SituationPlayerActing: React.FC<SituationPlayerActingProps> = ({ 
  gameState, 
  playerId, 
  onStateUpdate 
}) => {
  const { t } = useTranslation();

  const { advanceGame, isLoading } = useGameActions({
    gameCode: gameState.gameCode,
    playerId,
    onStateUpdate
  });

  const handleContinue = async () => {
    try {
      await advanceGame();
    } catch (err) {
      console.error('Failed to advance game:', err);
    }
  };

  return (
    <div className="flex flex-col items-center space-y-6">
      <SituationPanel 
        situation={gameState.currentSituation}
        title="Your Situation:"
      />
      
      <ActionButton 
        onClick={handleContinue} 
        loading={isLoading}
        variant="primary"
        size="lg"
      >
        {t("game.pageTitle.guessTheNumbers")}
      </ActionButton>
    </div>
  );
};

export default SituationPlayerActing;